import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
    service_interest: '',
    monthly_volume: '',
    termsAccepted: false,
    marketingConsent: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.termsAccepted) {
      setSubmitMessage('Please accept the Terms & Conditions and Privacy Policy to proceed.');
      return;
    }
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const { data, error } = await supabase
        .from('contact_inquiries')
        .insert([{
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          company: formData.company,
          message: formData.message,
          service_interest: formData.service_interest,
          monthly_volume: formData.monthly_volume,
          terms_accepted: formData.termsAccepted,
          marketing_consent: formData.marketingConsent,
          created_at: new Date().toISOString()
        }]);

      if (error) throw error;

      if (formData.marketingConsent) {
        await supabase.from('sms_consents').insert([{
          email: formData.email.trim().toLowerCase(),
          phone: formData.phone.trim(),
          company: formData.company.trim(),
          consent_given: true,
          consent_type: 'marketing',
          source: 'contact_form',
          created_at: new Date().toISOString()
        }]).catch(err => console.error('SMS consent insert error:', err));
      }

      setSubmitMessage('Thank you for your inquiry! We will contact you within 24 hours.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: '',
        service_interest: '',
        monthly_volume: '',
        termsAccepted: false,
        marketingConsent: false
      });
    } catch (error) {
      setSubmitMessage('There was an error submitting your inquiry. Please try again.');
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{paddingTop: '100px'}}>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Contact MEES HOLDINGS INC</h1>
          
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '3rem', alignItems: 'start'}}>
            <div>
              <h2 style={{color: '#2563eb', marginBottom: '1.5rem'}}>Get in Touch</h2>
              <p style={{marginBottom: '2rem', lineHeight: '1.8'}}>
                Ready to start your SMS marketing campaign? Contact our team to discuss your needs 
                and learn how MEES HOLDINGS INC can help grow your business with compliant SMS marketing solutions 
                through our partnerships with leading SMS providers.
              </p>

              <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px', marginBottom: '2rem'}}>
                <h3 style={{color: '#2563eb', marginBottom: '1rem'}}>Company Information</h3>
                <p><strong>MEES HOLDINGS INC</strong></p>
                <p>2022 E 9TH ST<br />BROOKLYN, NY 11223<br />United States</p>
                <p><strong>EIN:</strong> 93-4196857</p>
                <p><strong>Owner:</strong> Esther Buaki</p>
                <p><strong>Technical Lead:</strong> Biswanath Sahoo</p>
                <p style={{marginTop: '1rem'}}><strong>Email:</strong> info@meesmarketing.com</p>
                <p><strong>Support:</strong> support@meesmarketing.com</p>
                <p style={{marginTop: '0.5rem', fontSize: '0.9rem', color: '#6b7280'}}>
                  Note: Please use the contact form below or email us. We will respond within 24-48 business hours.
                </p>
              </div>

              <div style={{background: '#f0f9ff', padding: '2rem', borderRadius: '10px', border: '2px solid #2563eb'}}>
                <h3 style={{color: '#2563eb', marginBottom: '1rem'}}>Business Hours</h3>
                <p><strong>Monday - Friday:</strong> 9:00 AM - 6:00 PM EST</p>
                <p><strong>Saturday - Sunday:</strong> Closed</p>
                <p style={{marginTop: '1rem', fontSize: '0.9rem'}}>
                  <strong>Response Time:</strong> We respond to all inquiries within 24-48 business hours via email
                </p>
              </div>
            </div>

            <div className="form-container">
              <h2 style={{color: '#2563eb', marginBottom: '1.5rem'}}>Request Information</h2>
              
              {submitMessage && (
                <div style={{
                  background: submitMessage.includes('error') ? '#fef2f2' : '#f0f9ff',
                  color: submitMessage.includes('error') ? '#ef4444' : '#2563eb',
                  padding: '1rem',
                  borderRadius: '5px',
                  marginBottom: '1.5rem',
                  border: `2px solid ${submitMessage.includes('error') ? '#ef4444' : '#2563eb'}`
                }}>
                  {submitMessage}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your full legal name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Business Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your.name@company.com"
                    required
                  />
                  <small>Please use your business email address for verification purposes</small>
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Business Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+1 (123) 456-7890"
                    pattern="[+]?[0-9\s\-\(\)]+"
                    required
                  />
                  <small>Include country code. This number will be used for account verification.</small>
                </div>

                <div className="form-group">
                  <label htmlFor="company">Company/Business Name *</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Your registered business name"
                    required
                  />
                  <small>Enter your legal business name as registered with authorities</small>
                </div>

                <div className="form-group">
                  <label htmlFor="service_interest">Service Interest</label>
                  <select
                    id="service_interest"
                    name="service_interest"
                    value={formData.service_interest}
                    onChange={handleChange}
                  >
                    <option value="">Select a service</option>
                    <option value="sms_marketing">SMS Marketing</option>
                    <option value="a2p_messaging">A2P Messaging</option>
                    <option value="campaign_management">Campaign Management</option>
                    <option value="compliance_consulting">Compliance Consulting</option>
                    <option value="api_integration">API Integration</option>
                    <option value="enterprise_solutions">Enterprise Solutions</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="monthly_volume">Expected Monthly Message Volume</label>
                  <select
                    id="monthly_volume"
                    name="monthly_volume"
                    value={formData.monthly_volume}
                    onChange={handleChange}
                  >
                    <option value="">Select volume range</option>
                    <option value="under_1k">Under 1,000 messages</option>
                    <option value="1k_10k">1,000 - 10,000 messages</option>
                    <option value="10k_50k">10,000 - 50,000 messages</option>
                    <option value="50k_100k">50,000 - 100,000 messages</option>
                    <option value="100k_500k">100,000 - 500,000 messages</option>
                    <option value="over_500k">Over 500,000 messages</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Business Requirements & Use Case *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Please provide detailed information about:
• Your business type and industry
• Intended use of SMS marketing (promotional, transactional, notifications, etc.)
• Expected message volume per month
• Target audience and how you collect consent
• Current SMS provider (if any)
• Any specific questions about our reseller services"
                    required
                  ></textarea>
                  <small>Detailed information helps us provide better service recommendations and connect you with the right SMS provider</small>
                </div>

                <div className="form-group">
                  <div style={{display: 'flex', alignItems: 'flex-start', gap: '0.75rem', background: '#f0f9ff', padding: '1rem', borderRadius: '8px', border: '2px solid #3b82f6', marginBottom: '1rem'}}>
                    <input
                      type="checkbox"
                      id="termsAccepted"
                      name="termsAccepted"
                      checked={formData.termsAccepted}
                      onChange={handleChange}
                      required
                      style={{marginTop: '0.25rem', width: '16px', height: '16px'}}
                    />
                    <label htmlFor="termsAccepted" style={{fontSize: '0.9rem', lineHeight: '1.5', color: '#1e40af', fontWeight: '500', cursor: 'pointer'}}>
                      <strong>I accept the <a href="/terms" target="_blank" rel="noopener noreferrer" style={{color: '#2563eb', textDecoration: 'underline', fontWeight: '600'}}>Terms &amp; Conditions</a> and <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{color: '#2563eb', textDecoration: 'underline', fontWeight: '600'}}>Privacy Policy</a>.</strong>
                    </label>
                  </div>
                  <div style={{display: 'flex', alignItems: 'flex-start', gap: '0.75rem', background: '#f0f9ff', padding: '1rem', borderRadius: '8px', border: '2px solid #3b82f6'}}>
                    <input
                      type="checkbox"
                      id="marketingConsent"
                      name="marketingConsent"
                      checked={formData.marketingConsent}
                      onChange={handleChange}
                      style={{marginTop: '0.25rem', width: '16px', height: '16px'}}
                    />
                    <label htmlFor="marketingConsent" style={{fontSize: '0.9rem', lineHeight: '1.5', color: '#1e40af', fontWeight: '500', cursor: 'pointer'}}>
                      <strong>(Optional) I agree to receive recurring SMS marketing messages from MEES HOLDINGS INC regarding SMS marketing services and related business offerings. Message frequency may vary. Message &amp; data rates may apply. Reply STOP to opt out, HELP for help. Consent is not a condition of purchase.</strong>
                    </label>
                  </div>
                </div>

                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Send Inquiry'}
                </button>
              </form>

              <div style={{background: '#fef2f2', padding: '1.5rem', borderRadius: '8px', marginTop: '1rem', border: '2px solid #ef4444'}}>
                <h4 style={{color: '#dc2626', marginBottom: '0.75rem', fontSize: '1rem'}}>SMS Marketing Disclosure</h4>
                <div style={{fontSize: '0.9rem', color: '#dc2626', lineHeight: '1.5'}}>
                  <p style={{marginBottom: '0.5rem'}}>
                    <strong>• Message & Data Rates May Apply</strong> - Standard messaging rates from your carrier will apply
                  </p>
                  <p style={{marginBottom: '0.5rem'}}>
                    <strong>• Message Frequency Varies</strong> - You may receive up to 10 messages per month
                  </p>
                  <p style={{marginBottom: '0.5rem'}}>
                    <strong>• Opt-Out Instructions:</strong> Reply STOP to cancel, HELP for help
                  </p>
                  <p style={{marginBottom: '0.5rem'}}>
                    <strong>• Carrier Liability:</strong> Carriers are not liable for delayed or undelivered messages
                  </p>
                  <p style={{marginBottom: '0', fontWeight: '600'}}>
                    <strong>• Consent Not Required for Credit:</strong> If you receive messages about loan or credit products, consent to receive SMS is NOT required as a condition of purchase or to obtain credit
                  </p>
                </div>
              </div>

              <div style={{background: '#f0f9ff', padding: '1rem', borderRadius: '8px', marginTop: '1rem', border: '1px solid #3b82f6', textAlign: 'center'}}>
                <p style={{fontSize: '0.85rem', color: '#1e40af', margin: '0 0 0.5rem 0'}}>
                  <strong>A2P Compliant Service</strong> | Registered Business Entity | TCPA & CAN-SPAM Compliant
                </p>
                <p style={{fontSize: '0.8rem', color: '#1e40af', margin: '0'}}>
                  By submitting this form, you agree to our <a href="/sms-terms" style={{color: '#2563eb', textDecoration: 'underline'}}>SMS Terms & Conditions</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;